<template>
  <div>TrangXemChucVu</div>
</template>

<script>
export default {
  name: "TrangXemChucVu"
};
</script>


